export const DURATION_UNITS = ['ms', 's', 'm', 'h', 'd', 'w', 'M', 'y'];
export const DurationRegexp = new RegExp(`^(\\d+)(${DURATION_UNITS.join('|')})$`);
export const durationUnitDuration = {
    ms: 1,
    s: 1000,
    m: 1000 * 60,
    h: 1000 * 60 * 60,
    d: 1000 * 60 * 60 * 24,
    w: 1000 * 60 * 60 * 24 * 7,
    M: 1000 * 60 * 60 * 24 * 7 * 30,
    y: 1000 * 60 * 60 * 24 * 7 * 30 * 365,
};
//# sourceMappingURL=constants.js.map